import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CategoriaServiceService {

  constructor() { }

  private categoriaSeleccionadaSource = new BehaviorSubject<string>('');
  categoriaSeleccionada$ = this.categoriaSeleccionadaSource.asObservable();

  cambiarCategoria(categoria: string) {
    this.categoriaSeleccionadaSource.next(categoria);
  }
}
